module.exports = {
  // 导航
  nav: {
    index: "首页",
    about: "关于"
  },
  // copyright
  copyright: "©{year} 深圳卓锐网络科技有限公司版权所有",
  icp: '粤ICP备{icp}号',
  download: '立即下载',
  disclaimers: {
    text: '免责声明：本网页只可作参考用途，并不构成投资建议',
    tips: '投资有风险，入市需谨慎！'
  },
  contact: {
    customerService: '客服热线',
    preSalesService: '售前服务',
    technicalSupport: '技术支持'
  },
  appLabel: '客户端',
  index: {
    banner: {
      title: '财富未来 尽在掌中',
      tips: ['卓锐倾力打造港美股智能投资平台']
    },
    section: [
      {
        title: '一个账户  多样选择',
        tips: ['港股、美股，一个账户即可交易', '股票、ETF、窝轮、牛熊证、基金等，产品丰富，满足多元化的投资需求']
      },
      {
        title: '实时行情  毫秒更新',
        tips: ['港股LV2高级行情报价，10档买卖盘，毫秒级更新', '第一时间紧抓市场投资机会，让投资更精准']
      },
      {
        title: '环球视野  海量资讯',
        tips: ['早评晚评周评深度剖析市场热点，全球多方位金融资讯随时看', '总览全局，抢占先机']
      },
      {
        title: '智能工具  辅助交易',
        tips: ['千亿级市场消息，AI智能深度分析，提供资料参考', '智能订单，锁定成交价格，捕捉买卖良机']
      }
    ]
  },
  about: {
    banner: {
      text: '卓锐网络科技',
      desc: '立志成为互联网科技金融领先服务商'
    },
    company: {
      title: '公司简介',
      detail: `<p>深圳卓锐网络科技有限公司（以下简称卓锐网络科技）是一家从事互联网科技类产品研发的IT服务公司。公司立足深圳，业务辐射全球，是香港持牌券商卓锐证券的技术赋能平台。</p>
      <p>秉承“科技赋能金融”的理念布局科创行业，公司业务涵盖技术服务、产品开发、信息技术咨询、软件开发解决方案等，在股市行情数据、网上交易和金融信息服务等领域构筑了坚实的解决方案优势，开发并发布了包括主要操作系统（Windows、MacOS、Android及iOS）以及主流平台（包括微信及网页浏览器）的多平台产品线，后台技术架构采用最先进的微服+DevOps docker容器化方案。卓锐网络科技致力为证券公司、基金公司、银行、电商公司等提供极具竞争力的产品和解决方案，持续提升用户体验，为用户创造价值。</p>
      <p>公司以“客户至上”为服务使命，招揽了一群极富经验的互联网金融精英和大数据分析专业人才，开展自主研发。核心团队来自海通国际证券、招商银行、汇添富基金、腾讯、金蝶随手记等金融及互联网平台，有丰富的实战经验，具备超强的执行力和战斗力，致力于为客户打造流畅稳定、体验至上的互联网金融产品，开启愉悦的投资旅程。</p>`
    },
    contact: {
      title: '联系我们',
      location: {
        name: '深圳卓锐网络科技有限公司',
        address: '深圳市南山区软件产业基地1C19楼'
      }
    }
  },
};



// WEBPACK FOOTER //
// ./src/common/lang/zh-CN.js